import styles from 'styles/WrapUpScreen.module.css'
import classNames from 'classnames'
import { sendSocketMessage } from 'config/socket/socketUtil'

import _ from 'lodash'
import { useEffect } from 'react'

type WrapUpScreenPropsType = {
  data: {
    primaryImg: string,
    secondaryImg: string,
    videoUrl: string,
  };
  socketInstance?: any;
  srcWidthSize?: string,
  isTeacher?: boolean,
}

function WrapUpScreen({ data:{ primaryImg, secondaryImg, videoUrl },socketInstance, srcWidthSize, isTeacher }: WrapUpScreenPropsType) {
 
  useEffect(() => {
    const callbackFunction = (state: any) => {
      if(document.getElementById('myVideo')){
        const videoPlayer = document.getElementById('myVideo') as HTMLFormElement
        if(state.onPlay) {
          videoPlayer?.play();
        } else if(state.onPause) {
          videoPlayer?.pause();
        }
      }
    }
    socketInstance?.onMessage('WrapUpScreen', callbackFunction)
  },[])
  
  const onPlay = () => {
    sendSocketMessage({ state: { onPlay: true }, action: 'WrapUpScreen'})
  }

  const onPause = () => {
    sendSocketMessage({ state: { onPause: true }, action: 'WrapUpScreen'})
  }

  return (
    <div className={styles.container}>
      <div className={styles.primaryImgWrapper}>
          <div
            style={{backgroundImage: `url(${primaryImg})`}}
            className={styles.image}
          >
            {secondaryImg && <img
              src={secondaryImg}
              alt='src'
              className={classNames(srcWidthSize === 'wider' ? styles.widerImg : styles.secondaryImg)}
            /> } 
            {videoUrl && <video id="myVideo"  
                //onPlay={onPlay}
                //onPause={onPause}
                muted={isTeacher}
                controls
                className={styles.video}
                preload='auto'
                src={videoUrl}
              />}
              {isTeacher && <span className={styles.infoText}>Please ask the parent to play the video.</span>}
          </div>
      </div>
      
    </div>
  )
}

export default WrapUpScreen